import StringUtil from 'gw-portals-util-js/StringUtil';

const getFirstName = (person) => {
    if (person.firstName) {
        return person.firstName.charAt(0).toUpperCase() + person.firstName.slice(1);
    }
    return '';
};

const getFullName = (person) => {
    if (person.lastName && person.firstName) {
        const lastName = person.lastName.charAt(0).toUpperCase() + person.lastName.slice(1);
        const firstName = person.firstName.charAt(0).toUpperCase() + person.firstName.slice(1);
        return `${firstName} ${lastName}`;
    }
    return '';
};

const getFullNameWithTitle = (person) => {
    if (person.prefix && person.firstName && person.lastName) {
        const prefixFormatter = StringUtil.capitalizeFirstLetter(person.prefix);
        const firstNameFormatter = StringUtil.capitalizeFirstLetter(person.firstName);
        const lastNameFormatter = StringUtil.capitalizeFirstLetter(person.lastName);
        return `${prefixFormatter} ${firstNameFormatter} ${lastNameFormatter}`;
    }
    return '';
};

export default {
    getFullName,
    getFirstName,
    getFullNameWithTitle
};
